import { API_NAMES, initApi } from '@usas/ui-web/utils/HttpApiHelper';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const getSponsorsData = (state, setState) => {
  const api = initApi(API_NAMES.COMMON, state, setState);
  const url = `/Sponsor`;

  return api.executeArray ? api.executeArray(url, 'GET') : null;
};

const INITIAL_SPONSORS_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  areOptionsLoaded: false
};

const SponsorData = {
  INITIAL_SPONSORS_STATE,
  getSponsorsData
};

export default SponsorData;